module.exports = {
  TIMELINE: 'timeline',
  SEARCH: 'search',
  LINKS: 'links',
  ACTIVITY: 'activity'
}
